export var accelerateMax = 'cubic-bezier(1,0,1,1)';
export var accelerateMid = 'cubic-bezier(0.7,0,1,0.5)';
export var accelerateMin = 'cubic-bezier(0.8,0,1,1)';
export var decelerateMax = 'cubic-bezier(0,0,0,1)';
export var decelerateMid = 'cubic-bezier(0.1,0.9,0.2,1)';
export var decelerateMin = 'cubic-bezier(0.33,0,0.1,1)';
export var maxEasyEase = 'cubic-bezier(0.8,0,0.1,1)';
export var easyEase = 'cubic-bezier(0.33,0,0.67,1)';
export var linear = 'cubic-bezier(0,0,1,1)';